const topics = [
  { name: '顶流塌房', count: '128.6万' },
  { name: '综艺翻车', count: '96.3万' },
  { name: '带货翻车', count: '203.1万' },
  { name: '导演潜规则', count: '356.7万' },
  { name: '明星恋情', count: '178.2万' },
  { name: '人设崩塌', count: '145.8万' },
  { name: '选秀内幕', count: '89.5万' },
  { name: '网红造假', count: '112.4万' },
  { name: '代言风波', count: '67.9万' },
  { name: '剧组纠纷', count: '54.3万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 rounded-full bg-primary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">热门话题</h2>
        </div>

        <div className="flex flex-wrap gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group cursor-pointer inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-accent-300/60 hover:bg-accent-50 transition-all duration-300"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}